<h1 mat-dialog-title> Firma Grupo Pago </h1> <br/>

<mat-dialog-content>
    
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">
            
            <mat-label> Ingrese Código OTP </mat-label>
            
            <input matInput type = "text" placeholder = "Código OTP" [(ngModel)] = "data.codigo" required> 
            
        </mat-form-field>
    </p>

</mat-dialog-content>

<mat-dialog-actions>
    
    <button mat-button class = "mat-raised-button btn-success" (click) = "onGuardarClick()"> 
        <i class = "fa fa-download"> </i> Ingresar
    </button>
    
    <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()"> 
        <i class = "fa fa-trash"> </i> Salir 
    </button>
    
</mat-dialog-actions>